import { getAccessToken } from "../../services/authService"

// AI Workspace requests. The server holds the OpenRouter key, picks the model and sets the cost.
const endpoints = { ideas: "/ai/ideas", scene: "/ai/scene-analysis", script: "/ai/script-analysis" }

const creditRequest = async (path, method = "GET") => {
  const token = getAccessToken()
  if (!token) throw new Error("Please sign in again.")
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, { method, headers: { Authorization: `Bearer ${token}` } })
  const json = await response.json().catch(() => ({}))
  if (!response.ok || !json.data) throw new Error(json.message || "Credit balance unavailable.")
  return json.data
}
export const getStandardBalance = () => creditRequest("/ai/usage")
export const claimCreditWarning = () => creditRequest("/ai/credits/low-warning", "POST")

export const getScriptPages = (scriptId) => creditRequest(`/ai/script-pages/${scriptId}`)

export const runAiTool = async ({ tool, scriptId, sceneId, options, notes }) => {
  const token = getAccessToken()
  if (!token) throw new Error("Please sign in again.")
  const body = { options, notes }
  if (scriptId) body.scriptId = scriptId
  if (tool === "scene") body.sceneId = sceneId
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${endpoints[tool]}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, 'X-AI-Request-Id': window.crypto.randomUUID() },
    body: JSON.stringify(body),
  })
  const json = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(json.message || "Something went wrong. Please try again.")
  return json.data
}

// AI Production Elements: identify (suggestions only) and add approved items. Errors keep their HTTP status (409 = refresh).
const postJson = async (path, body) => {
  const token = getAccessToken()
  if (!token) throw new Error("Please sign in again.")
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, {
    method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, 'X-AI-Request-Id': window.crypto.randomUUID() }, body: JSON.stringify(body),
  })
  const json = await response.json().catch(() => ({}))
  if (!response.ok) { const err = new Error(json.message || "Something went wrong. Please try again."); err.status = response.status; throw err }
  return json.data
}
export const identifyProductionElements = (body) => postJson("/ai/production-elements/identify", body)
export const addProductionElements = (body) => postJson("/ai/production-elements/add", body)
